export default "__VITE_ASSET__DI8_5nc7__"